export enum Departaments {
    Salse = 1,
    Parts = 2,
    Service = 3,
    
  }